import DevicesSectionControls from 'components/Controls/DevicesSection'

const Controls = () => {}

Controls.DevicesSection = DevicesSectionControls

export default Controls
